import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import MainPage from '../../shared-components/main-page/MainPage';
import { H1 } from '../../shared-components/typography/Title';
import MyAppointments from './MyAppointments';
import MyInstallations from './MyInstallations';

function MyCalendar() {
  const { t } = useTranslation();
  return (
    <MainPage>
      <H1 text={t('my_calendar')} />  
      <Tabs>
        <Tabs.TabPane key="1" tab={t('appointments')}>
          <MyAppointments />
        </Tabs.TabPane>
        <Tabs.TabPane key="2" tab={`${t('installations')} (${t('scheduled')})`}>
          <MyInstallations />
        </Tabs.TabPane>
      </Tabs>
    </MainPage>
  );
}

export default MyCalendar;
